/* LinksRenderer.js */

"use strict";
const Registrations = require("../../../../../../../RegistrationNamespaces");
const MoveVeilComponent = require("./../../move_veil/MoveVeilComponent");
const _ = require("lodash");

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("links-column");
        this._rootElem.component = this._model;

        this._planEditIcon = document.createElement("actionable-icon-gl");
        this._planEditIcon.dataset.icon = "osmanager.edit_os_plan_associations";
        this._planEditIcon.setAttribute("title", "Edit");

        this._planMoveIcon = document.createElement("actionable-icon-gl");
        this._planMoveIcon.dataset.icon = "osmanager.move_os_plan_associations";
        this._planMoveIcon.setAttribute("title", "Move");

        this._planRemoveIcon = document.createElement("actionable-icon-gl");
        this._planRemoveIcon.dataset.icon = "common.trash_bin";
        this._planRemoveIcon.setAttribute("title", "Remove");

        this._planValidateIcon = document.createElement("actionable-icon-gl");
        this._planValidateIcon.dataset.icon = "common.log_link";
        this._planValidateIcon.setAttribute("title", "Validate");
        this.deviceIds = [];

        this._registerListeners();
        this.render();
    }

    /* *******************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS  */
    /* *******************************************/

    _shutdown() {
        let promiseAll = [];
        if (this._model._modalUserFeedback && !_.isEmpty(this._model._modalUserFeedback._veil)) {
            const veilName = _.get(
                this._model,
                "_modalUserFeedback._veil.content.constructor.name",
                ""
            );
            const veilTitle = _.get(this._model, "_modalUserFeedback._veil.content.title", "");
            // TODO workaround for PE-11108 to be refactored
            // Tests on veilTitle to prevent summary veil of Remove Invalid Devices action to be closed
            if (
                veilName !== "RunNowComponent" &&
                veilName !== "RemoveInvalidDevicesComponent" &&
                veilTitle !== "Move Completed" &&
                veilTitle !== "Remove Completed"
            ) {
                promiseAll = [this._model._modalUserFeedback.hideDisplayed()];
            }
        }
        return Promise.all(promiseAll).then(() => {
            this._unregisterListeners();
            this._planEditIcon.remove();
            this._planEditIcon = undefined;
            this._planRemoveIcon.remove();
            this._planRemoveIcon = undefined;
            this._planMoveIcon.remove();
            this._planMoveIcon = undefined;
            this._planValidateIcon.remove();
            this._planValidateIcon = undefined;
            this.deviceIds = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            return Promise.resolve();
        });
    }

    _registerListeners() {
        this._planRemoveIcon.addEventListener(
            "click",
            (this._onClickPlanRemoveIcon = this._onClickPlanRemoveIcon.bind(this))
        );
        this._planEditIcon.addEventListener(
            "click",
            (this._onClickEditIcon = this._onClickEditIcon.bind(this))
        );
        this._planMoveIcon.addEventListener(
            "click",
            (this._onClickPlanMoveIcon = this._onClickPlanMoveIcon.bind(this))
        );
        this._planValidateIcon.addEventListener(
            "click",
            (this._onClickPlanValidateIcon = this._onClickPlanValidateIcon.bind(this))
        );
        this._model.on("Links", (this._onLinks = this._onLinks.bind(this)));
    }

    _unregisterListeners() {
        this._planRemoveIcon.removeEventListener("click", this._onClickPlanRemoveIcon);
        this._planEditIcon.removeEventListener("click", this._onClickEditIcon);
        this._planMoveIcon.removeEventListener("click", this._onClickPlanMoveIcon);
        this._planValidateIcon.removeEventListener("click", this._onClickPlanValidateIcon);
        this._model.removeAllListeners("Links");
    }

    /** navigate inside view tab */
    _switchView(switchTo, params) {
        this._model._gameEditor.setActiveView(
            switchTo,
            [
                {
                    value: {
                        fqn: Registrations.OS_PLAN_EDITOR_VIEW_DETAILS,
                        viewState: {configExecutionEntity: this._model.getValue()},
                    },
                    content: "Details",
                    left: {
                        arrow: {
                            direction: "left",
                        },
                    },
                },
            ],
            params
                ? params
                : {
                      configExecutionEntity: this._model.getValue(),
                  }
        );
    }

    _onClickPlanRemoveIcon() {
        this._model.removeDevice();
    }
    _onClickEditIcon() {
        this._model._switchToEditImage();
    }

    _onClickPlanMoveIcon() {
        let isGroupBy = _.get(this._model._value, "groupBy", null);
        let groupkey = this._model._value;
        if (isGroupBy) {
            this._model._gameEditor.loadDevicesForGroupKey(groupkey.id).then((devices) => {
                this.deviceIds = devices.map((device) => {
                    return device._id;
                });
                this.moveVeilLaunch();
            });
        } else {
            this.deviceIds = [this._model._value._id];
            this.moveVeilLaunch();
        }
    }

    moveVeilLaunch() {
        let moveVeilComponent = new MoveVeilComponent(
            this._model._logger,
            this._model._gameEditor,
            this.deviceIds
        );
        return this._model._modalUserFeedback
            .displayCustom(moveVeilComponent, {dontHide: true})
            .then((result) => {
                return this.moveToPlan(result.type, result.id);
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._model._logger.warn(
                        {error: err},
                        "OsPlanDetails._onClickPlanMoveIcon() - User Canceled"
                    );
                    this._model._modalUserFeedback.hideDisplayed();
                    return;
                } else if (err.stack) {
                    this._model._modalUserFeedback.hideDisplayed();
                    // this._model._logger.warn(
                    //     { error: err },
                    //     "OsPlanDetails._onClickPlanMoveIcon() - Error"
                    // );
                    return;
                } else {
                    this._model._logger.warn(
                        {error: err},
                        "OsPlanDetails._onClickPlanMoveIcon() - Error"
                    );
                    return this._model._modalUserFeedback.displayError(err);
                }
            });
    }

    _onClickPlanValidateIcon() {
        this._switchView(Registrations.OS_PLAN_EDITOR_SUBVIEW_VALIDATE);
    }

    /* jshint ignore:start */

    async moveToPlan(moveType, planNameOrID) {
        try {
            const deviceIds = this.deviceIds;
            const groupKey = _.get(this._model._value, "groupBy", null)
                ? this._model._value.id
                : "";
            if (moveType === "new") {
                const newPlanId = await this._model._gameEditor.createPlan(planNameOrID.trim());
                await newPlanId.setAction(this._model._gameEditor.getPlan().action);
                await newPlanId.update();
                await this._model._gameEditor.moveDevices(newPlanId.id, deviceIds);
            } else {
                await this._model._gameEditor.moveDevices(planNameOrID, deviceIds, groupKey);
            }
        } catch (error) {
            if (error.errorCode && error.errorCode === "EntityAlreadyExists") {
                return this._model._modalUserFeedback.displayError(error);
            }
            this._logger.warn({error: error}, "OsPlanEditor.moveDevices() error");
        }
    }
    /* jshint ignore:end */

    /* ******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS   */
    /* START PUBLIC COMPONENT RENDERER METHODS  */
    /* ******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setIcons(this._model._isCompleted);
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* ******************************************/
    /* END COMPONENT RENDERER METHODS           */
    /* START HANDLER METHODS                    */
    /* ******************************************/

    _onLinks(newVal) {
        this._model.setValue(newVal);
        this._setIcons(this._model._isCompleted);
    }

    /* ******************************************/
    /* END HANDLER METHODS                      */
    /* START PRIVATE API METHODS                */
    /* ******************************************/

    _setIcons(newVal) {
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._planEditIcon);
        this._rootElem.appendChild(this._planMoveIcon);
        // this._rootElem.appendChild(this._planValidateIcon);
        this._rootElem.appendChild(this._planRemoveIcon);
        this._planEditIcon.setDisabled(newVal);
        this._planRemoveIcon.setDisabled(newVal);
        this._planMoveIcon.setDisabled(newVal);
        this._planValidateIcon.setDisabled(newVal);
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
